export default "__VITE_PUBLIC_ASSET__dbbbf246__"